module.exports = __webpack_public_path__ + "static/img/course6.cca3201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/course6.png
// module id = r26W
// module chunks = 63